import React, { ChangeEvent } from 'react'

import styled from 'styled-components'

import { Input } from '..'
import { useUser } from '../../context'
import { ProfileRole } from '../../types'
import { translateStatus } from '../../utilFunctions/transformFunc'

const TabsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  flex-wrap: wrap;

  & > input {
    border: none;
    background: transparent;
    padding: 4px 6px;
    min-width: 120px;

    &:focus {
      outline: none;
      border: none;
    }
  }
`

const TabBtn = styled.button<{
  $isMenu: boolean
  $userRole: ProfileRole | null
}>`
  border: none;
  background: ${(props) =>
    props.$userRole === 'admin' ? ' #e9f6fa' : '#fcfbf2'};
  color: ${(props) => (props.$userRole === 'admin' ? '#08a8d2' : '#ffab00')};
  padding: ${(props) => (props.$isMenu ? '10px 20px' : '8px')};
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  font-size: ${(props) => (props.$isMenu ? '14px' : '12px')};
  border-width: ${(props) => (props.$userRole === 'admin' ? '0' : '1px')};
  border-style: solid;

  &.active {
    background: ${(props) =>
      props.$userRole === 'admin' ? '#08a8d2' : '#ffab00'};
    border-color: ${(props) =>
      props.$userRole === 'admin' ? '#08a8d2' : '#ffab00'};
    color: ${(props) => (props.$userRole === 'admin' ? '#fff' : '#424242')};
  }
`

const Tabs = ({
  id,
  tabs,
  selectedValue,
  handleTag,
  inputFn,
  isMenu = false,
}: {
  id: string
  tabs: string[]
  selectedValue?: string
  handleTag: (tag: string) => void
  inputFn?: {
    inputValue: string
    setInputValue: (value: string) => void
    handleHashtagKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
    inputClass?: string
  }
  isMenu?: boolean
}) => {
  const { onEditionMode, userRole } = useUser()
  const inputValue = inputFn?.inputValue ?? ''

  const handleHashtagKeyDown = inputFn?.handleHashtagKeyDown

  const setInputValue = (e: ChangeEvent<HTMLInputElement>) => {
    inputFn?.setInputValue(e.target.value)
  }

  return (
    <TabsContainer>
      {tabs.map((type) => (
        <TabBtn
          key={type}
          className={selectedValue && selectedValue === type ? 'active' : ''}
          onClick={() => handleTag(type)}
          type="button"
          $isMenu={isMenu}
          $userRole={userRole}
        >
          {id === 'status-tags' ? translateStatus(type) : type}
        </TabBtn>
      ))}

      {inputFn && (
        <Input
          id={id}
          name={id}
          value={inputValue}
          onChange={(e) => setInputValue(e)}
          onKeyDown={handleHashtagKeyDown}
          placeholder="Escribe y presiona Enter"
          disabled={!onEditionMode}
          inputClass={inputFn?.inputClass}
        />
      )}
    </TabsContainer>
  )
}

export default Tabs
